/**
 * Import this file to ensure all required styles are loaded for @servicetitan/assist-ui components
 *
 * Usage:
 * import '@servicetitan/assist-ui/styles';
 *
 * Or import in your main app file:
 * import '@servicetitan/assist-ui/styles';
 */

// Import required Anvil2 utility styles
import '@servicetitan/anvil2/assets/css-utils/utils.css';

// You can add any additional styles specific to assist-ui here if needed
// import './assist-ui-specific-styles.css';
